import React, { useMemo } from "react"
import { ReactNode, useState } from "react"
import { WizardStepProps } from "../CreateOrganisationWizard/CreateOrganisationWizard"

export function Wizard(
    {children}: { children: (props : WizardStepProps<any>) => JSX.Element}
){

    const [currentStep, setCurrentStep] = useState(0)


    const nextStep = () => {
  
        setCurrentStep(currentStep + 1)
        
    }

    const previousStep = () => {
        if(currentStep === 1){
            return
        }

        setCurrentStep(currentStep -1)
    }

    return(
        <div className="mx-auto max-w-screen-2xl h-full w-full px-1 md:px-8 pb-8 md:py-8 text-contrast">
            <div className="flex-wrap flex h-full justify-center gap-6 md:w-2/3 mx-auto">            
            {children({
                currentStep,
                onComplete : nextStep,
                goBack: previousStep
            })}
        </div>
        </div>
    )
}